import React, { createContext } from 'react'

import type { KinerjaProfil } from 'types/kinerja'
import type { PengawasProfile } from 'types/kinerja-ks'

interface Data {
  isLoading: boolean
  isSuccess: boolean
  isError: boolean

  // Guru / Kepala Sekolah
  profile: KinerjaProfil | null
  isGuru: boolean
  isKs: boolean
  isKsDefinitif: boolean
  isKsPlt: boolean

  // Pamong / Kepala Sekolah SPNF
  isPamong: boolean
  isKepalaSkbPlt: boolean
  isKepalaSkbDefinitif: boolean
  isKepalaSkb: boolean

  // Pengawas Sekolah
  profilePs: PengawasProfile | null
  isPengawasSekolah: boolean
  isPengawasSekolahOnly: boolean

  // Kepala Dinas Pendidikan
  isKepalaDinas: boolean
  isKepalaDinasAndPengawasSekolah: boolean

  // Pegawai Pengawas Sekolah, Tim Kerja, & Pejabat Penilai Kerja
  isPegawaiPengawasSekolah: boolean
  isTimKinerjaPengawasSekolah: boolean
  isPPKPengawasSekolah: boolean
  isProfilePSPegawaiLoading: boolean
  isProfilePSPegawaiFetched: boolean

  // Penilik SPNF
  isPenilikPegawai: boolean
  isProfilePenilikPegawaiLoading: boolean
  isProfilePenilikPegawaiFetched: boolean
  isTKPenilik?: boolean
  isPPKPenilik?: boolean

  // GPK
  isGpkPegawai: boolean
  isGpkTimKinerja: boolean

  // Centralize leave function
  leave: () => void
}

export const RoleContext = createContext<Data>({
  isLoading: false,
  isSuccess: false,
  isError: false,

  // Guru / Kepala Sekolah
  profile: null,
  isGuru: false,
  isKs: false,
  isKsDefinitif: false,
  isKsPlt: false,

  // Pamong / Kepala Sekolah SPNF
  isPamong: false,
  isKepalaSkbPlt: false,
  isKepalaSkbDefinitif: false,
  isKepalaSkb: false,

  // Pengawas Sekolah
  profilePs: null,
  isPengawasSekolah: false,
  isPengawasSekolahOnly: false,

  // Kepala Dinas Pendidikan
  isKepalaDinas: false,
  isKepalaDinasAndPengawasSekolah: false,

  // Pegawai Pengawas Sekolah, Tim Kerja, & Pejabat Penilai Kerja
  isPegawaiPengawasSekolah: false,
  isTimKinerjaPengawasSekolah: false,
  isPPKPengawasSekolah: false,
  isProfilePSPegawaiLoading: false,
  isProfilePSPegawaiFetched: false,

  // Penilik SPNF
  isPenilikPegawai: false,
  isProfilePenilikPegawaiLoading: false,
  isProfilePenilikPegawaiFetched: false,
  isTKPenilik: false,
  isPPKPenilik: false,

  // GPK
  isGpkPegawai: false,
  isGpkTimKinerja: false,

  // Centralize leave function
  leave: () => {},
})

export default function useRoleContext() {
  const context = React.useContext(RoleContext)

  if (!context)
    throw new Error('useRoleContext must be used within a RoleContext')

  return context
}
